export const endpoints = {
  automation: code => `/dashboard/automations/${code}`,
  automations: () => '/dashboard/automations',
  products: code => `/dashboard/automations/${code}/products`,
  spendingSummary: code => `/dashboard/automations/${code}/spending-summary`,
  acceptanceRate: code => `/dashboard/automations/${code}/acceptance-rate`,
  orders: code => `/dashboard/automations/${code}/orders`,
  orderDetail: (code, orderCode) => `/dashboard/automations/${code}/orders/${orderCode}`,
  sendReminder: ({ code }) => `/dashboard/automations/${code}/send-reminder`,
  detailDuplicate: code => `/dashboard/automations/${code}/duplicate`,
  automationOrderDelete: (code, orderCode) => `/dashboard/automations/${code}/order/${orderCode}`,
  upcomingSends: code => `/dashboard/automations/${code}/upcoming-sends`,
  submitToApproval: code => `/dashboard/automations/${code}/send-for-approval`,
  goLiveFlags: code => `/dashboard/automations/${code}/go-live-checks`
};
